import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["type", "disabled", "id"]
const _hoisted_2 = ["disabled"]


import { useRouter } from "vue-router";
import ButtonPreloader from "@/components/common/other/ButtonPreloader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppBtn',
  props: {
  type: { type: String, required: false, default: () => "button" },
  to: { type: String, required: false, default: () => "" },
  class: { type: String, required: false, default: () => "page-btn" },
  style: { type: Object, required: false, default: () => null },
  loading: { type: Boolean, required: false, default: () => false },
  disabled: { type: Boolean, required: false, default: () => false },
  id: { type: String, required: false, default: () => "" },
},
  emits: ["click"],
  setup(__props, { emit }) {

const props = __props



const router = useRouter();



const click = () => {
  if (props.to && router.currentRoute.value.path !== props.to) {
    router.push(props.to);
  }
  emit("click");
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.to)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: __props.type,
          onClick: click,
          class: _normalizeClass(props.class),
          style: _normalizeStyle({
      ...__props.style,
      cursor: __props.loading ? 'wait' : __props.disabled ? 'not-allowed' : 'pointer',
    }),
          disabled: __props.disabled || __props.loading,
          id: __props.id
        }, [
          (__props.loading)
            ? (_openBlock(), _createBlock(ButtonPreloader, { key: 0 }))
            : _renderSlot(_ctx.$slots, "default", { key: 1 })
        ], 14, _hoisted_1))
      : _createCommentVNode("", true),
    (__props.to)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: __props.to,
          style: _normalizeStyle(__props.style),
          class: "page-btn-link"
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              onClick: click,
              class: _normalizeClass(props.class),
              style: _normalizeStyle({
        cursor: __props.loading ? 'wait' : __props.disabled ? 'not-allowed' : 'pointer',
      }),
              disabled: __props.disabled || __props.loading
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 14, _hoisted_2)
          ]),
          _: 3
        }, 8, ["to", "style"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})